module.exports = __webpack_public_path__ + "img/c04051b.png";